import React, { useState } from 'react';
import './contact.css';
import event from "../../main_assets/Event.png";
import evet from "../../main_assets/evet.png";
import pastEventImg from "../../main_assets/pastEventImg.png";
import { useNavigate } from 'react-router-dom';

const Contact = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const upcomingEvents = Array(9).fill({
    title: "Event Title and Name Event Title and Name",
    description: "Brief description about the event in here.",
    location: "Buea, Cameroon",
    date: "10th November 2024"
  });

  const pastEvents = [
    {
      title: "Discovering your peace in times of hardship, Chaos, pain and discomfort",
      description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsidunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrice",
      location: "Buea, Cameroon",
      image: pastEventImg,
      date: "10th November 2024"
    },
    {
      title: "Discovering your peace in times of hardship, Chaos, pain and discomfort",
      description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsidunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrice",
      location: "Buea, Cameroon",
      image: pastEventImg,
      date: "10th November 2024"
    },
    {
      title: "Discovering your peace in times of hardship, Chaos, pain and discomfort",
      description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsidunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrice",
      location: "Buea, Cameroon",
      image: pastEventImg,
      date: "10th November 2024"
    },
    {
      title: "Discovering your peace in times of hardship, Chaos, pain and discomfort",
      description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsidunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrice",
      location: "Buea, Cameroon",
      image: pastEventImg,
      date: "10th November 2024"
    },
    {
      title: "Discovering your peace in times of hardship, Chaos, pain and discomfort",
      description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsidunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrice",
      location: "Buea, Cameroon",
      image: pastEventImg,
      date: "10th November 2024"
    },
  ];

  // State for Load More logic
  const [visibleCount, setVisibleCount] = useState(4);

  const loadMore = () => {
    setVisibleCount((prevCount) => prevCount + 4);
  };

  const visiblePastEvents = pastEvents.slice(0, visibleCount);

  const handleRegisterClick = () => {
    navigate('/register'); 
  };

//   if (loading)
//   return (
//     <div className="loading-container">
//       <div className="spinner"></div>
//       <p>Loading projects...</p>
//     </div>
//   );
// if (error)
//   return (
//     <div className="error-container">
//       <div className="error-icon">⚠️</div>
//       <p>Error: {error}</p>
//     </div>
//   );


  // if (loading) {
  //   return (
  //     <div className="flex items-center justify-center min-h-screen">
  //       <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-red-600"></div>
  //       <p className="ml-4 text-lg">Loading Events...</p>
  //     </div>
  //   );
  // }



  return (
    <div className="contact section__padding-contact">
      {/* Hero Section */}
      <div className="flex flex-col md:flex-row mb-16">
        {/* Previous hero section content */}
        <div className="flex-1 md:flex-[0.7]">
          <img
            src={event}
            alt="Design event audience"
            className="w-full h-full object-cover"
          />
        </div>

        <div className="flex-1 md:flex-[0.3] px-0 py-8 md:p-8 flex items-center justify-center">
          <div className="max-w-md">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 text-black" style={{fontFamily: "Poppins-SemiBold"}}>
              Discover the Biggest Event In Design
            </h1>

            <hr className="my-6 border border-[#0000006E]" />

            <div className="mb-8">
              <h2 className="text-2xl font-semibold mb-2" style={{fontFamily: "Poppins-SemiBold", color: "#CD3333", lineHeight: "1.1"}}>
                Event Title and Name Event Title and Name 
              </h2>
              <p className="text-gray-600 mb-4" style={{fontFamily: "Poppins-Light", lineHeight: ".8", fontSize: "14px"}}>
                Brief description about the event in here.
              </p>
              <p className="text-gray-500" style={{fontFamily: "Poppins-Light", lineHeight: "0.2", fontSize: "14px"}}>
                Buea, Cameroon | 10th November 2024
              </p>
            </div>

            <div className="ulev__info-event-buttons flex gap-4">
              <button className="register-btnn bg-red-500 text-white px-6 py-2 hover:bg-red-600 transition-colors" style={{fontFamily: "Poppins-Light"}} onClick={handleRegisterClick}>
                Register
              </button>
              <button className="sponsor-btnn border border-red-500 text-red-500 px-6 py-2 hover:bg-red-50 transition-colors" style={{fontFamily: "Poppins-Light"}} onClick={handleRegisterClick}>
                Become A Sponsor
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="my-6 border-t border-[#0000006E]"></div>

      {/* Upcoming Events Section */}
      <div className="section__paddinga">
        <h2 className="text-4xl font-bold mb-6" style={{fontFamily: "Poppins-SemiBold", color: "#CD3333"}}>
          Upcoming Events
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {upcomingEvents.map((event, index) => (
            <div key={index} className="flex flex-col">
              <img
                src={evet}
                alt="Event"
                className="w-full h-64 object-cover mb-4"
              />
              <h3 className="text-xl font-semibold mb-2" style={{fontFamily: "Poppins-SemiBold", lineHeight: "1.1"}}>
                {event.title}
              </h3>
              <p className="text-gray-600 mb-2" style={{fontFamily: "Poppins-Light", fontSize: "14px", lineHeight: ".8"}}>
                {event.description}
              </p>
              <p className="text-gray-500 mb-4" style={{fontFamily: "Poppins-Light", fontSize: "14px", lineHeight: ".8"}}>
                {event.location} | {event.date}
              </p>
              <div className="ulev__info-event-buttons flex gap-4">
                <button className="register-btnn bg-red-500 text-white px-4 py-1 text-sm hover:bg-red-600 transition-colors" style={{fontFamily: "Poppins-Light"}} onClick={handleRegisterClick}>
                  Register
                </button>
                <button className="sponsor-btnn border border-red-500 text-red-500 px-4 py-1 text-sm hover:bg-red-50 transition-colors" style={{fontFamily: "Poppins-Light"}}>
                  Become A Sponsor
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="my-16 border-t border-[#0000006E]"></div>

      {/* Past Events Section */}
      <div className="section__paddinga">
        <div className="flex justify-between items-center mb-4 md:mb-8">
          <h2 className="font-bold" style={{fontFamily: "Poppins-SemiBold", fontSize: "clamp(28px, 4vw, 37px)",}}>
            Past Events
          </h2>
          <button className="text-sm" style={{fontFamily: "Poppins-Regular"}}>
            Filter +
          </button>
        </div>

        {visiblePastEvents.map((event, index) => (
        <div key={index} className="mb-16">
          <div className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-8`}>
            <div className="flex-1">
              <img
                src={event.image}
                alt={event.title}
                className="w-full h-[400px] object-cover"
              />
            </div>
            <div className="flex-1 flex flex-col justify-start">
              <div className={`flex flex-col lg:flex-row justify-between items-start gap-14 ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
                <div className="flex-1">
                  <div 
                    className="text-left" 
                    style={{
                      direction: 'ltr',   
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-start', 
                    }}
                  >
                    <h3 
                      className="text-2xl font-semibold mb-4 text-[#CD3333]"
                      style={{
                        fontFamily: "Poppins-SemiBold",
                      }}
                    >
                      {event.title}
                    </h3>
                    <p 
                      className="text-gray-600 mb-4"
                      style={{
                        fontFamily: "Poppins-Light", 
                        fontSize: "14px", 
                        lineHeight: "1.5",
                      }}
                    >
                      {event.description}
                    </p>
                  </div>

                  <button 
                    className={`bg-red-500 text-white px-6 py-1 flex items-center gap-2 hover:bg-red-600 transition-colors mt-2 ${
                      index % 2 === 1 ? 'mr-auto' : 'ml-auto'
                    }`}
                    style={{fontFamily: "Poppins-Light"}}
                  >
                    Watch full event 
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                </div>
                <div className={`flex-none ${index % 2 === 1 ? 'lg:text-left' : 'lg:text-right'}`}>
                  <p 
                    className="text-gray-500" 
                    style={{fontFamily: "Poppins-Light", fontSize: "14px"}}
                  >
                    {event.location} <br/> {event.date}
                  </p>
                </div>
              </div>
            </div>
          </div>
          {index < visiblePastEvents.length - 1 && (
            <div className="my-16 border-t border-[#0000006E]"></div>
          )}
        </div>
      ))}

      {visibleCount < pastEvents.length && (
        <div className="load-more-container" style={{ display: 'flex', justifyContent: 'center' }}>
          <button
            className="load-more-button"
            style={{ fontFamily: "Poppins-SemiBold", color: "#CD3333", fontWeight: "600", textAlign: "center" }}
            onClick={loadMore}
          >
            Load More
          </button>
        </div>
      )}
      </div>
    </div>
  );
};

export default Contact;











// import React, { useState, useEffect } from 'react';
// import { collection, query, where, orderBy, getDocs } from 'firebase/firestore';
// import { db } from '../../firebase';
// import './contact.css';
// import event from "../../main_assets/Event.png";
// import evet from "../../main_assets/evet.png";
// import pastEventImg from "../../main_assets/pastEventImg.png";

// const Contact = () => {
//   const [upcomingEvents, setUpcomingEvents] = useState([]);
//   const [pastEvents, setPastEvents] = useState([]);
//   const [visibleCount, setVisibleCount] = useState(4);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchEvents = async () => {
//       try {
//         setLoading(true);
//         const eventsRef = collection(db, 'events');
        
//         // Fetch upcoming events (events with start date in the future)
//         const upcomingQuery = query(
//           eventsRef, 
//           where('startDate', '>', new Date()),
//           orderBy('startDate', 'asc')
//         );
        
//         // Fetch past events (events with start date in the past)
//         const pastQuery = query(
//           eventsRef, 
//           where('startDate', '<', new Date()),
//           orderBy('startDate', 'desc')
//         );

//         // Execute queries
//         const upcomingSnapshot = await getDocs(upcomingQuery);
//         const pastSnapshot = await getDocs(pastQuery);

//         // Transform snapshots to arrays
//         const upcomingEventsData = upcomingSnapshot.docs.map(doc => ({
//           id: doc.id,
//           ...doc.data(),
//           startDate: doc.data().startDate?.toDate(), 
//           endDate: doc.data().endDate?.toDate()
//         }));

//         const pastEventsData = pastSnapshot.docs.map(doc => ({
//           id: doc.id,
//           ...doc.data(),
//           startDate: doc.data().startDate?.toDate(),
//           endDate: doc.data().endDate?.toDate()
//         }));

//         setUpcomingEvents(upcomingEventsData);
//         setPastEvents(pastEventsData);
//         setLoading(false);
//       } catch (err) {
//         console.error('Error fetching events:', err);
//         setError('Failed to load events');
//         setLoading(false);
//       }
//     };

//     fetchEvents();
//   }, []);

//   const loadMore = () => {
//     setVisibleCount((prevCount) => prevCount + 4);
//   };

//   const visiblePastEvents = pastEvents.slice(0, visibleCount);

//   // Helper function to format date
//   const formatDate = (date) => {
//     if (!date) return 'Date Not Specified';
//     return new Intl.DateTimeFormat('en-US', {
//       day: 'numeric',
//       month: 'long',
//       year: 'numeric'
//     }).format(date);
//   };

//   if (loading) {
//     return <div>Loading events...</div>;
//   }

//   if (error) {
//     return <div>Error: {error}</div>;
//   }

//   return (
//     <div className="contact section__padding-contact">
//       {/* Hero Section - use first upcoming event or a default */}
//       {upcomingEvents.length > 0 && (
//         <div className="flex flex-col md:flex-row mb-16">
//           {/* Previous hero section content with dynamic data */}
//           <div className="flex-1 md:flex-[0.7]">
//             <img
//               src={upcomingEvents[0].coverImage || event}
//               alt="Event Cover"
//               className="w-full h-full object-cover"
//             />
//           </div>

//           <div className="flex-1 md:flex-[0.3] py-4 px-0 md:p-8 flex items-center justify-center">
//             <div className="max-w-md">
//               <h1 className="text-4xl md:text-5xl font-bold mb-6 text-black" style={{fontFamily: "Poppins-SemiBold"}}>
//                 {/* {upcomingEvents[0].title} */}
//                 Discover the Biggest Event In Design
//               </h1>

//               <hr className="my-6 border border-[#0000006E]" />

//               <div className="mb-8">
//                 <h2 className="text-2xl font-semibold mb-2" style={{fontFamily: "Poppins-SemiBold", color: "#CD3333", lineHeight: "1.1"}}>
//                   {upcomingEvents[0].title}
//                 </h2>
//                 <p className="text-gray-600 mb-4" style={{fontFamily: "Poppins-Light", lineHeight: ".8", fontSize: "14px"}}>
//                   {upcomingEvents[0].subtitle}
//                 </p>
//                 <p className="text-gray-500" style={{fontFamily: "Poppins-Light", lineHeight: "0.2", fontSize: "14px"}}>
//                   {upcomingEvents[0].location} | {formatDate(upcomingEvents[0].startDate)}
//                 </p>
//               </div>

//               <div className="ulev__info-event-buttons flex gap-4">
//                 <button className="register-btnn bg-red-500 text-white px-6 py-2 hover:bg-red-600 transition-colors" style={{fontFamily: "Poppins-Light"}}>
//                   Register
//                 </button>
//                 <button className="sponsor-btnn border border-red-500 text-red-500 px-6 py-2 hover:bg-red-50 transition-colors" style={{fontFamily: "Poppins-Light"}}>
//                   Become A Sponsor
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       <div className="my-6 border-t border-[#0000006E]"></div>

//       {/* Upcoming Events Section */}
//       <div className="section__paddinga">
//         <h2 className="text-4xl font-bold mb-6" style={{fontFamily: "Poppins-SemiBold", color: "#CD3333"}}>
//           Upcoming Events
//         </h2>
        
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//           {upcomingEvents.map((event) => (
//             <div key={event.id} className="flex flex-col">
//               <img
//                 src={event.coverImage || evet}
//                 alt="Event"
//                 className="w-full h-64 object-cover mb-4"
//               />
//               <h3 className="text-xl font-semibold mb-2" style={{fontFamily: "Poppins-SemiBold", lineHeight: "1.1"}}>
//                 {event.title}
//               </h3>
//               <p className="text-gray-600 mb-2" style={{fontFamily: "Poppins-Light", fontSize: "14px", lineHeight: ".8"}}>
//                 {event.subtitle}
//               </p>
//               <p className="text-gray-500 mb-4" style={{fontFamily: "Poppins-Light", fontSize: "14px", lineHeight: ".8"}}>
//                 {event.location} | {formatDate(event.startDate)}
//               </p>
//               <div className="ulev__info-event-buttons flex gap-4">
//                 <button className="register-btnn bg-red-500 text-white px-4 py-1 text-sm hover:bg-red-600 transition-colors" style={{fontFamily: "Poppins-Light"}}>
//                   Register
//                 </button>
//                 <button className="sponsor-btnn border border-red-500 text-red-500 px-4 py-1 text-sm hover:bg-red-50 transition-colors" style={{fontFamily: "Poppins-Light"}}>
//                   Become A Sponsor
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       <div className="my-16 border-t border-[#0000006E]"></div>

//       {/* Past Events Section */}
//       <div className="section__paddinga">
//         <div className="flex justify-between items-center mb-8">
//           <h2 className="text-4xl font-bold" style={{fontFamily: "Poppins-SemiBold"}}>
//             Past Events
//           </h2>
//           <button className="text-sm" style={{fontFamily: "Poppins-Regular"}}>
//             Filter +
//           </button>
//         </div>

//         {visiblePastEvents.map((event, index) => (
//           <div key={event.id} className="mb-16">
//             <div className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-8`}>
//               <div className="flex-1">
//                 <img
//                   src={event.coverImage || pastEventImg}
//                   alt={event.title}
//                   className="w-full h-[400px] object-cover"
//                 />
//               </div>
//               <div className="flex-1 flex flex-col justify-start">
//                 <div className={`flex flex-col lg:flex-row justify-between items-start gap-14 ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
//                   <div className="flex-1">
//                     <div 
//                       className="text-left" 
//                       style={{
//                         direction: 'ltr',   
//                         display: 'flex',
//                         flexDirection: 'column',
//                         alignItems: 'flex-start', 
//                       }}
//                     >
//                       <h3 
//                         className="text-2xl font-semibold mb-4 text-[#CD3333]"
//                         style={{
//                           fontFamily: "Poppins-SemiBold",
//                         }}
//                       >
//                         {event.title}
//                       </h3>
//                       <p 
//                         className="text-gray-600 mb-4"
//                         style={{
//                           fontFamily: "Poppins-Light", 
//                           fontSize: "14px", 
//                           lineHeight: "1.5",
//                         }}
//                       >
//                         {event.subtitle}
//                       </p>
//                     </div>

//                     <button 
//                       className={`bg-red-500 text-white px-6 py-1 flex items-center gap-2 hover:bg-red-600 transition-colors mt-2 ${
//                         index % 2 === 1 ? 'mr-auto' : 'ml-auto'
//                       }`}
//                       style={{fontFamily: "Poppins-Light"}}
//                     >
//                       Watch full event 
//                       <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                         <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//                       </svg>
//                     </button>
//                   </div>
//                   <div className={`flex-none ${index % 2 === 1 ? 'lg:text-left' : 'lg:text-right'}`}>
//                     <p 
//                       className="text-gray-500" 
//                       style={{fontFamily: "Poppins-Light", fontSize: "14px"}}
//                     >
//                       {event.location} <br/> {formatDate(event.startDate)}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             {index < visiblePastEvents.length - 1 && (
//               <div className="my-16 border-t border-[#0000006E]"></div>
//             )}
//           </div>
//         ))}

//         {visibleCount < pastEvents.length && (
//           <div className="load-more-container" style={{ display: 'flex', justifyContent: 'center' }}>
//             <button
//               className="load-more-button"
//               style={{ fontFamily: "Poppins-SemiBold", color: "#CD3333", fontWeight: "600", textAlign: "center", paddingTop: "4rem" }}
//               onClick={loadMore}
//             >
//               Load More
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Contact;
